
export default {
  placeInput: {
    'findAPlace': 'Hely keresése',
    'place': 'Hely',
    'addRouteStop': 'Köztes úticél hozzáadása',
    'routePlace': 'Köztes úticél',
    'routeDestination': 'Úticél',
    'placeNameRequired': 'Meg kell adni egy helynevet',
    'yourLocation': 'Az Ön tartózkodási helye',
    'couldNotDetermineYourLocation': 'Tartózkodási helyét nem sikerült meghatározni. Győződjék meg róla, hogy megadta a szükséges engedélyeket',
    'useYourLocation': 'Az Ön jelenlegi tartózkodási helyének felhasználása',
    'removeInput': 'Hely/bevitel eltávolítása',
    'directions': 'Irányok',
    'fromYourBrowser': 'A készülékéről',
    'addStartingPlace': 'Kiindulási hely hozzáadása',
    'startingPlace': 'Kiindulás hely',
    'openInputOptions': 'Beviteli lehetőségek megnyitása',
    'addInput': 'További hely hozzáadása',
    'switchCoords': 'Koordináták átkapcsolása',
    'rawCoordinate': 'Nyers szél., hossz koordináta',
    'fillOrRemoveInput': 'Keressen egy helyet vagy használja a jobboldali térképgombot',
    'noPlaceFound': 'Nincs eredmény',
    'unknownSearchPlaceError': 'Ismeretlen helykeresési hiba',
    'approximateDistance': 'Hozzávetőleges távolság egyenes vonalban a térkép jelenlegi középpontjától',
    'couldNotDetermineYourPreciseLocationUsingPreviousLocation': 'Nem sikerült meghatározni a pontos tartózkodási helyét. Helyette az előző tartózkodási helyét fogjuk használni',
    'pleaseTypeSomething': 'A kereséshez írjon be valamit',
    'toggleDirect': 'Váltás innen közvetlenül a következő helyre',
    'clickOnTheMapToSelectAPlace': 'Válasszon egy helyet a térképre kattintva',
    'clickOnTheMapBtnToPickAPlace': 'Erre a gombra kattintva kiválaszthat egy helyet a térképen ehhez az útponthoz',
    'goToDirectionsMode': 'Kattintson az irányok gombra az útvonaltervezési módra váltáshoz',
    'clickToSearchAndShowResultsOnTheMap': 'Kattintson a kereséshez és az eredmények megjelenítéséhez a térképen'
  }
}
